import { render, staticRenderFns } from "./InfoWebsite.vue?vue&type=template&id=b72a7cc8&scoped=true&"
import script from "./InfoWebsite.vue?vue&type=script&lang=js&"
export * from "./InfoWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72a7cc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72a7cc8')) {
      api.createRecord('b72a7cc8', component.options)
    } else {
      api.reload('b72a7cc8', component.options)
    }
    module.hot.accept("./InfoWebsite.vue?vue&type=template&id=b72a7cc8&scoped=true&", function () {
      api.rerender('b72a7cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoWebsite.vue"
export default component.exports